import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { isChoiceQuestion, questionInputName, type ExperienceQuestion } from "@/lib/experience-questions";

type ExperienceQuestionFieldsProps = {
  questions: ExperienceQuestion[];
  initialAnswers?: Record<string, string>;
  disabled?: boolean;
};

function multiSelectDefaults(value: string | undefined) {
  if (!value) return new Set<string>();
  try {
    const parsed = JSON.parse(value);
    return new Set(Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === "string") : []);
  } catch {
    return new Set<string>();
  }
}

/** Same guest inputs in checkout and the operator's preview. Values stay in the enclosing form. */
export function ExperienceQuestionFields({ questions, initialAnswers = {}, disabled = false }: ExperienceQuestionFieldsProps) {
  return <>{questions.map((question) => {
    const name = questionInputName(question.id);
    const answer = initialAnswers[question.id] ?? "";
    const selected = multiSelectDefaults(answer);
    return <fieldset className="experience-guest-question full" key={question.id}>
      <legend>{question.label}{question.required ? " (required)" : " (optional)"}</legend>
      {question.type === "multi_select" ? <div className="experience-choice-inputs">{question.options?.map((option) => <label key={option.id}><input type="checkbox" name={name} value={option.id} defaultChecked={selected.has(option.id)} disabled={disabled} />{option.label}</label>)}</div>
        : question.type === "single_select" ? <select aria-label={question.label} name={name} required={question.required} defaultValue={answer} disabled={disabled}><option value="">Choose an option</option>{question.options?.map((option) => <option key={option.id} value={option.id}>{option.label}</option>)}</select>
        : question.type === "long_text" ? <Textarea aria-label={question.label} name={name} maxLength={5000} required={question.required} defaultValue={answer} disabled={disabled} />
        : <Input aria-label={question.label} name={name} maxLength={500} required={question.required} defaultValue={answer} disabled={disabled} />}
      {isChoiceQuestion(question) && question.additionalTextPrompt ? <label>{question.additionalTextPrompt}<Textarea name={`${name}__note`} maxLength={5000} defaultValue={initialAnswers[`${question.id}__note`] ?? ""} disabled={disabled} /></label> : null}
    </fieldset>;
  })}</>;
}
